import React from "react";
import { Icon, AppTopNavi, MenuItem, MenuItemDivider, Menu, SubMenu, Button, Dialog, WithTooltip, Tooltip, AppTopNaviItem } from "@abb/abb-common-ux-react";
import History from "../../utilities/History";
import { v4 as uuidv4 } from "uuid";
import propertyActions from "../../flux/actions/PropertyActions";
import actionHeaderCommonStore from "../../flux/stores/shared/ActionHeaderCommonStore";
import actionHeaderEditStore from "../../flux/stores/shared/ActionHeaderEditStore";

import IActionHeaderFormData, { IActionHeaderEditData } from "../../models/shared/ActionHeaderData";
import * as CONSTANTS from "../../utilities/Constants";
import propertyDeleteStore from "../../flux/stores/property/DeleteStore";
import triggerNotifications from "../../utilities/TriggerNotifications";
import instrumentTypeActions from "../../flux/actions/InstrumentTypeActions";
import instrumentTypeDeleteStore from "../../flux/stores/instrumentType/DeleteStore";
import instrumentActions from "../../flux/actions/InstrumentActions";
import sourceActions from "../../flux/actions/SourceActions";
import sourceDeleteStore from "../../flux/stores/source/DeleteStore";
import productActions from "../../flux/actions/ProductActions";
import productDeleteStore from "../../flux/stores/product/DeleteStore";
import stationActions from "../../flux/actions/StationActions";
import stationDeleteStore from "../../flux/stores/station/DeleteStore";
import instrumentDeleteStore from "../../flux/stores/Instrument/DeleteStore";
import gradeActions from "../../flux/actions/GradeActions";
import gradeDeleteStore from "../../flux/stores/grade/DeleteStore";
import testplanDeleteStore from "../../flux/stores/testplan/DeleteStore";
import sampleDeleteStore from "../../flux/stores/sample/DeleteStore";
import testplanActions from "../../flux/actions/TestplanActions";
import sampleActions from "../../flux/actions/SampleActions";
import sampleExportStore from "../../flux/stores/sample/ExportStore";
import { Translation } from "react-i18next";
import scannerActions from "../../flux/actions/ScannerAction";
import scannerListStore from '../../flux/stores/scanner/ListStore';
import { IScannerViewData } from '../../models/scanner/ScannerViewData';
import { ISidebarDetail, SidebarDetail } from '../../models/shared/SidebarDetail';
import { ScannerFormData } from '../../models/scanner/ScannerFormData';
import scannerByIdStore from '../../flux/stores/scanner/ByIdStore';
import scannerDeleteStore from "../../flux/stores/scanner/DeleteStore";

export const ConfigMenu = {
    Modules: 1,
    AccManagement: 2,
    Utility: 3
}

interface IActionHeaderState {
    moduleName: string;
    createData: any;
    editData: any;
    deleteTitle: string;
    deleteId: string;
    isEnableViewAll: boolean;
    exportId: string;
    deleteRequesId: string;
    show: boolean;
    showManageInstrument: boolean;
    showBackup: boolean;
    hide: boolean;
    deleteModalVisible: boolean;
    deleteMessage: string;
    pathname: string;
    menuName: string;
    subMenuName: string;
    isSubMenu: boolean;
    active: boolean;
    downloadData: any;
    isExportShow: boolean;
    isReportDropdownShow: boolean;
    isEnableReport: boolean;
    listData: any[];
    isSampleWithScanner: boolean;
    activeItem: any;
    isScannerSettingActive: boolean;
    showConfiguration: boolean;
    activeConfigMenu: any;
    activeMainMenu: any;
    isMeasurementDropdownShow: boolean;

}

class ActionHeader extends React.Component<{ location: any }, IActionHeaderState> {
    _mount: boolean;
    _messages: [];
    private _listData: any[];

    constructor(props: any) {
        super(props);

        this._mount = false;

        this.state = {
            moduleName: "",
            createData: {},
            editData: {},
            show: false,
            showManageInstrument: false,
            showBackup: false,
            hide: false,
            deleteTitle: "",
            deleteId: "",
            isEnableViewAll: false,
            exportId: "",
            deleteRequesId: "",
            deleteModalVisible: false,
            deleteMessage: "",
            pathname: "",
            menuName: "",
            subMenuName: "",
            isSubMenu: false,
            active: false,
            downloadData: {},
            isExportShow: false,
            isReportDropdownShow: false,
            isEnableReport: false,
            listData: [],
            isSampleWithScanner: false,
            activeItem: null,
            isScannerSettingActive: false,
            showConfiguration: false,
            activeConfigMenu: ConfigMenu.Modules,
            activeMainMenu: CONSTANTS.SAMPLE_INDEX_URL,
            isMeasurementDropdownShow: false
        };
    }

    componentWillUnmount() {
        this._mount = false;
    }

    componentDidMount() {
        this._mount = true;

        document.addEventListener('mouseup', (e: any) => {
            var reportcontainer = document.getElementById('reportcontainer');
            if (reportcontainer.contains(e.target)) {
                this.setState({
                    isReportDropdownShow: false
                })
            }

            var container = document.getElementById('container');
            if (container?.contains(e.target)) {
                this.toggleConfiguration(this.state.showConfiguration)
            }
        });

        propertyDeleteStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            if (this._mount) {
                this._messages = state.message;
            }
        });

        instrumentTypeDeleteStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            if (this._mount) {
                this._messages = state.message;
            }
        });

        sourceDeleteStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            if (this._mount) {
                this._messages = state.message;
            }
        });
        productDeleteStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            if (this._mount) {
                this._messages = state.message;
            }
        });

        stationDeleteStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            if (this._mount) {
                this._messages = state.message;
            }
        });

        sampleDeleteStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            if (this._mount) {
                this._messages = state.message;
            }
        });

        scannerDeleteStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            if (this._mount) {
                this._messages = state.message;
            }
        });

        testplanDeleteStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            if (this._mount) {
                this._messages = state.message;
            }
        });
        gradeDeleteStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            if (this._mount) {
                this._messages = state.message;
            }
        });


        instrumentDeleteStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            if (this._mount) {
                this._messages = state.message;
            }
        });


        if (this._mount) {
            this.setInitialPath();
        }


        actionHeaderCommonStore.on(CONSTANTS.CHANGE_EVENT, (state: IActionHeaderFormData) => {
            if (this._mount) {
                this.setState({
                    moduleName: state.moduleName,
                    createData: state.createData
                });
            }
        });

        actionHeaderEditStore.on(CONSTANTS.CHANGE_EVENT, (state: IActionHeaderEditData) => {

            if (this._mount) {
                this.setState({
                    moduleName: state.moduleName,
                    editData: state.editData,
                    deleteTitle: state.deleteTitle,
                    deleteId: state.deleteId,
                    isEnableViewAll: state.isEnableViewAll || false,
                    exportId: state.exportId,
                    deleteRequesId: state.deleteRequestId,
                    deleteMessage: state.deleteMessage,
                    isEnableReport: state.isEnableReport,
                    isSampleWithScanner: false
                });
            }
        });

        sampleExportStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            if (this._mount) {
                this.setState({
                    downloadData: state.downloadData
                });
            }
        });

        scannerListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            if (this._mount) {
                this._listData = [];
                const data = state.data.result as IScannerViewData[];
                const items: ISidebarDetail[] = [];
                data.forEach(element => {
                    items.push(new SidebarDetail(element.id, element.name));
                });
                this._listData = items;
            }
        });


        scannerByIdStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
            if (this._mount) {
                this.setState({
                    activeItem: state.data
                });
            }
        });

        this.getAllScannerData();
    }
    componentDidUpdate(prevProps: any) {
        if (this.props !== prevProps) {
            this.getAllScannerData();
        }
    }

    getAllScannerData = () => {
        scannerActions.getAll(1, 0, CONSTANTS.SORT_CREATEDON, CONSTANTS.SORT_ORDER, "%20").then(() => {
            this.setState({
                listData: this._listData
            });
        }).catch((e) => console.log("Error ", e))
    }
    private setInitialPath() {
        const pathname = this.props.location.pathname;
        if (pathname === "/" || pathname.toLowerCase().includes(CONSTANTS.PATH_SAMPLE)) {
            this.setState({
                menuName: CONSTANTS.MENU_SAMPLE
            });
        } else if (pathname.toLowerCase().includes(CONSTANTS.PATH_PROPERTY)) {
            this.setState({
                menuName: CONSTANTS.MENU_PROPERTY
            });
        } else if (pathname.toLowerCase().includes(CONSTANTS.PATH_GRADE)) {
            this.setState({
                menuName: CONSTANTS.MENU_GRADE
            });
        } else if (pathname.toLowerCase().includes(CONSTANTS.PATH_SAMPLE)) {
            this.setState({
                menuName: CONSTANTS.MENU_SAMPLE
            });
        } else if (pathname.toLowerCase().includes(CONSTANTS.PATH_REPORT_TEMPLATE)) {
            this.setState({
                menuName: CONSTANTS.MENU_REPORT_TEMPLATE
            });
        } else if (pathname.toLowerCase().includes(CONSTANTS.PATH_PRODUCT)) {
            this.setState({
                menuName: CONSTANTS.MENU_PRODUCT
            });
        }
        else if (pathname.toLowerCase().includes(CONSTANTS.PATH_SOURCE)) {
            this.setState({
                menuName: CONSTANTS.MENU_SOURCE
            });
        } else if (pathname.toLowerCase().includes(CONSTANTS.PATH_MANAGE_INSTRUMENT)) {
            this.setState({
                menuName: CONSTANTS.MENU_MANAGE_INSTRUMENT,
                isSubMenu: true
            });
            if (pathname.toLowerCase().includes(CONSTANTS.PATH_INSTRUMENT_TYPE)) {
                this.setState({
                    subMenuName: CONSTANTS.SUBMENU_INSTRUMENT_TYPE
                });
            } else if (pathname.toLowerCase().includes(CONSTANTS.PATH_TEST_PLAN)) {
                this.setState({
                    subMenuName: CONSTANTS.SUBMENU_TEST_PLAN
                });
            } else if (pathname.toLowerCase().includes(CONSTANTS.PATH_INSTRUMENT_STATION)) {
                this.setState({
                    subMenuName: CONSTANTS.SUBMENU_INSTRUMENT_STATION
                });
            } else if (pathname.toLowerCase().includes(CONSTANTS.PATH_INSTRUMENT)) {
                this.setState({
                    subMenuName: CONSTANTS.SUBMENU_INSTRUMENT
                });
            }

        } else if (pathname.toLowerCase().includes(CONSTANTS.PATH_ACCOUNT_MANAGEMENT)) {
            this.setState({
                menuName: CONSTANTS.MENU_ACCOUNT_MANAGEMENT,
                isSubMenu: true
            });
            if (pathname.toLowerCase().includes(CONSTANTS.PATH_USERS)) {
                this.setState({
                    subMenuName: CONSTANTS.SUBMENU_USERS
                });
            } else if (pathname.toLowerCase().includes(CONSTANTS.PATH_ROLES_AND_PERMISSIONS)) {
                this.setState({
                    subMenuName: CONSTANTS.SUBMENU_ROLES_AND_PERMISSIONS
                });
            }

        } else if (pathname.toLowerCase().includes(CONSTANTS.PATH_UTILITY)) {
            this.setState({
                menuName: CONSTANTS.MENU_UTILITY,
                isSubMenu: true
            }, () => {

                if (pathname.toLowerCase().includes(CONSTANTS.PATH_BACKUP_AND_RESTORE)) {
                    this.setState({
                        subMenuName: CONSTANTS.SUBMENU_BACKUP_AND_RESTORE
                    });
                } else if (pathname.toLowerCase().includes(CONSTANTS.PATH_SCANNER)) {
                    this.setState({
                        subMenuName: CONSTANTS.SUBMENU_SCANNER
                    });
                } else {
                    this.setState({
                        subMenuName: CONSTANTS.SUBMENU_SETTINGS
                    });
                }
            });
            if (pathname.toLowerCase().includes(CONSTANTS.PATH_BACKUP_AND_RESTORE)) {
                this.setState({
                    subMenuName: CONSTANTS.SUBMENU_BACKUP_AND_RESTORE
                });
            }
        } else if (pathname.toLowerCase().includes(CONSTANTS.PATH_INSTRUMENT_DASHBOARD)) {
            this.setState({
                menuName: CONSTANTS.MENU_SCANNER
            });
        }
        else if (pathname.toLowerCase().includes(CONSTANTS.PATH_INSTRUMENT_DASHBOARD)) {
            this.setState({
                menuName: CONSTANTS.MENU_INSTRUMENT_DASHBOARD
            });
        }
        this.setState({
            activeMainMenu: pathname
        })
    }

    private onHomeClick = () => {
        this.setState({
            menuName: CONSTANTS.MENU_SAMPLE,
            isSubMenu: false
        });
        History.push("/");
    }

    private onCreateClick = () => {
        if (this.state.moduleName === CONSTANTS.MODULE_PROPERTY) {
            History.push(CONSTANTS.PROPERTY_CREATE_URL, this.state.createData);
        } else if (this.state.moduleName === CONSTANTS.MODULE_PRODUCT) {
            History.push(CONSTANTS.PRODUCT_CREATE_URL, this.state.createData);
        } else if (this.state.moduleName === CONSTANTS.MODULE_GRADE) {
            History.push(CONSTANTS.GRADE_CREATE_URL, this.state.createData);
        } else if (this.state.moduleName === CONSTANTS.MODULE_INSTRUMENTTYPE) {
            History.push(CONSTANTS.INSTRUMENTTYPE_CREATE_URL, this.state.createData);
        } else if (this.state.moduleName === CONSTANTS.MODULE_TESTPLAN) {
            History.push(CONSTANTS.TESTPLAN_CREATE_URL, this.state.createData);
        } else if (this.state.moduleName === CONSTANTS.MODULE_INSTRUMENT) {
            History.push(CONSTANTS.INSTRUMENT_CREATE_URL, this.state.createData);
        } else if (this.state.moduleName === CONSTANTS.MODULE_SOURCE) {
            History.push(CONSTANTS.SOURCE_CREATE_URL, this.state.createData);
        } else if (this.state.moduleName === CONSTANTS.MODULE_STATION) {
            History.push(CONSTANTS.STATION_CREATE_URL, this.state.createData);
        } else if (this.state.moduleName === CONSTANTS.MODULE_SAMPLE) {
            if (this.state.listData.length > 0) {
                this.setState({
                    isSampleWithScanner: !this.state.isSampleWithScanner
                })
            } else {
                History.push(CONSTANTS.SAMPLE_CREATE_URL, this.state.createData);
            }
        } else if (this.state.moduleName === CONSTANTS.MODULE_USERS) {
            History.push(CONSTANTS.USER_CREATE_URL, this.state.createData);
        } else if (this.state.moduleName === CONSTANTS.MODULE_ROLES_AND_PERMISSIONS) {
            History.push(CONSTANTS.ROLESANDPERMISSIONS_CREATE_URL, this.state.createData);
        } else if (this.state.moduleName === CONSTANTS.MODULE_REPORT_TEMPLATE) {
            History.push(CONSTANTS.REPORT_CREATE_URL, this.state.createData);
        } else if (this.state.moduleName === CONSTANTS.MODULE_SCANNER) {
            History.push(CONSTANTS.SCANNER_CREATE_URL, this.state.createData);
        }
    }

    private onEditClick = () => {

        if (this.state.moduleName === CONSTANTS.MODULE_PROPERTY) {
            History.push(CONSTANTS.PROPERTY_CREATE_URL, this.state.editData);
        } else if (this.state.moduleName === CONSTANTS.MODULE_GRADE) {
            History.push(CONSTANTS.GRADE_CREATE_URL, this.state.editData);
        } else if (this.state.moduleName === CONSTANTS.MODULE_INSTRUMENTTYPE) {
            History.push(CONSTANTS.INSTRUMENTTYPE_CREATE_URL, this.state.editData);
        } else if (this.state.moduleName === CONSTANTS.MODULE_INSTRUMENT) {
            History.push(CONSTANTS.INSTRUMENT_CREATE_URL, this.state.editData);
        } else if (this.state.moduleName === CONSTANTS.MODULE_SOURCE) {
            History.push(CONSTANTS.SOURCE_CREATE_URL, this.state.editData);
        } else if (this.state.moduleName === CONSTANTS.MODULE_STATION) {
            History.push(CONSTANTS.STATION_CREATE_URL, this.state.editData);
        } else if (this.state.moduleName === CONSTANTS.MODULE_PRODUCT) {
            History.push(CONSTANTS.PRODUCT_CREATE_URL, this.state.editData);
        } else if (this.state.moduleName === CONSTANTS.MODULE_TESTPLAN) {
            History.push(CONSTANTS.TESTPLAN_CREATE_URL, this.state.editData);
        } else if (this.state.moduleName === CONSTANTS.MODULE_SAMPLE) {
            History.push(CONSTANTS.SAMPLE_CREATE_URL, this.state.editData);
        } else if (this.state.moduleName === CONSTANTS.MODULE_USERS) {
            History.push(CONSTANTS.USER_CREATE_URL, this.state.editData);
        } else if (this.state.moduleName === CONSTANTS.MODULE_SCANNER) {
            History.push(CONSTANTS.SCANNER_CREATE_URL, this.state.editData);
        }
    }

    private onExportClick = () => {
        sampleActions.export(this.state.exportId)
            .then(() => {
                triggerNotifications.success(["Sample exported"]).then();

                this.setState({
                    isExportShow: false
                })
            }
            ).catch((messages) => {
                triggerNotifications.errors(messages);
            });
    }

    private onExportDataClick = () => {
        sampleActions.exportWithMeasurement(this.state.exportId)
            .then(() => {
                triggerNotifications.success(["Measurement exported"]).then();
                this.setState({
                    isExportShow: false
                })
            }
            ).catch((messages) => {
                triggerNotifications.errors(messages);
            });
    }

    private onDeleteClick = () => {
      const ids: any = [];      
      ids.push(this.state.deleteId);
        if (this.state.moduleName === CONSTANTS.MODULE_PROPERTY) {
            propertyActions.delete(this.state.deleteId, this.state.deleteRequesId)
                .then(() => {
                    triggerNotifications.success(this._messages);
                }).catch((error) => {
                    triggerNotifications.errors(error.message, error.data);
                });
        } else if (this.state.moduleName === CONSTANTS.MODULE_GRADE) {
            gradeActions.deleteMultiple(ids, this.state.deleteRequesId)
                .then(() => {
                    triggerNotifications.success(this._messages);
                }).catch((error) => {
                    triggerNotifications.errors(error.message, error.data);
                });
        } else if (this.state.moduleName === CONSTANTS.MODULE_INSTRUMENTTYPE) {
            instrumentTypeActions.delete(this.state.deleteId, this.state.deleteRequesId)
                .then(() => {
                    triggerNotifications.success(this._messages);
                }).catch((error) => {
                    triggerNotifications.errors(error.message, error.data);
                });
        } else if (this.state.moduleName === CONSTANTS.MODULE_SOURCE) {
            sourceActions.delete(this.state.deleteId, this.state.deleteRequesId)
                .then(() => {
                    triggerNotifications.success(this._messages);
                }).catch((error) => {
                    triggerNotifications.errors(error.message, error.data);
                });

        } else if (this.state.moduleName === CONSTANTS.MODULE_PRODUCT) {
            productActions.deleteMultiple(ids, this.state.deleteRequesId)
                .then(() => {
                    triggerNotifications.success(this._messages);
                }).catch((error) => {
                    triggerNotifications.errors(error.message, error.data);
                });
        }
        else if (this.state.moduleName === CONSTANTS.MODULE_STATION) {
            stationActions.delete(this.state.deleteId, this.state.deleteRequesId)
                .then(() => {
                    triggerNotifications.success(this._messages);
                }).catch((error) => {
                    triggerNotifications.errors(error.message, error.data);
                });
        } else if (this.state.moduleName === CONSTANTS.MODULE_INSTRUMENT) {
            instrumentActions.deleteMultiple(ids, this.state.deleteRequesId)
                .then(() => {
                    triggerNotifications.success(this._messages);
                }).catch((error) => {
                    triggerNotifications.errors(error.message, error.data);
                });
        } else if (this.state.moduleName === CONSTANTS.MODULE_TESTPLAN) {
            testplanActions.deleteMultiple(ids, this.state.deleteRequesId)
                .then(() => {
                    triggerNotifications.success(this._messages);
                }).catch((error) => {
                    triggerNotifications.errors(error.message, error.data);
                });
        } else if (this.state.moduleName === CONSTANTS.MODULE_SAMPLE) {
            sampleActions.delete(this.state.deleteId, this.state.deleteRequesId)
                .then(() => {
                    triggerNotifications.success(this._messages);
                }).catch((error) => {
                    triggerNotifications.errors(error.message, error.data);
                });
        } else if (this.state.moduleName === CONSTANTS.MODULE_SCANNER) {
            scannerActions.delete(this.state.deleteId, this.state.deleteRequesId)
                .then(() => {
                    triggerNotifications.success(this._messages);
                }).catch((error) => {
                    triggerNotifications.errors(error.message, error.data);
                });
        }

        this.setState({ deleteModalVisible: false });
    }

    private onViewClick = () => {
        if (this.state.moduleName === CONSTANTS.MODULE_PROPERTY) {
            History.push(CONSTANTS.PROPERTY_VIEW_ALL);
        } else if (this.state.moduleName === CONSTANTS.MODULE_GRADE) {
            History.push(CONSTANTS.GRADE_VIEW_ALL);
        } else if (this.state.moduleName === CONSTANTS.MODULE_INSTRUMENTTYPE) {
            History.push(CONSTANTS.INSTRUMENTTYPE_VIEW_ALL);
        } else if (this.state.moduleName === CONSTANTS.MODULE_TESTPLAN) {
            History.push(CONSTANTS.TESTPLAN_VIEW_ALL);
        } else if (this.state.moduleName === CONSTANTS.MODULE_INSTRUMENT) {
            History.push(CONSTANTS.INSTRUMENT_VIEW_ALL);
        } else if (this.state.moduleName === CONSTANTS.MODULE_PRODUCT) {
            History.push(CONSTANTS.PRODUCT_VIEW_ALL);
        } else if (this.state.moduleName === CONSTANTS.MODULE_SOURCE) {
            History.push(CONSTANTS.SOURCE_VIEW_ALL);
        } else if (this.state.moduleName === CONSTANTS.MODULE_STATION) {
            History.push(CONSTANTS.STATION_VIEW_ALL);
        } else if (this.state.moduleName === CONSTANTS.MODULE_SAMPLE) {
            History.push(CONSTANTS.SAMPLE_VIEW_ALL);
        } else if (this.state.moduleName === CONSTANTS.MODULE_USERS) {
            History.push(CONSTANTS.USER_VIEW_ALL);
        } else if (this.state.moduleName === CONSTANTS.MODULE_SCANNER) {
            History.push(CONSTANTS.SCANNER_VIEW_ALL);
        }
    }

    private onReportClick = () => {
        this.setState({
            isReportDropdownShow: !this.state.isReportDropdownShow
        })
    }
    private onMeasurementClick = () => {
        this.setState({
            isMeasurementDropdownShow: !this.state.isMeasurementDropdownShow
        })
    }


    private onReportLinkClick = (reportType: string) => {
        if (this.state.moduleName === CONSTANTS.MODULE_SAMPLE) {
            window.open(`${CONSTANTS.SAMPLE_REPORT}/${reportType}/${this.state.editData.id}`, "_blank");
        }
    }

    private onExportCall = () => {
        this.setState({
            isExportShow: !this.state.isExportShow
        })
    }

    private openDialog = () => {
        this.setState({ deleteModalVisible: true });
    }


    private onSelect = (pathname: any, active: boolean, isSubMenu: boolean) => {
        const arr = pathname.split("-");
        if (arr.length === 2) {
            const prefix = arr[0].indexOf(" ") !== -1 ? arr[0].split(" ")[0] + arr[0].split(" ")[1] : arr[0];
            let suffix;
            if ((arr[1].split(" ")).length > 2) {
                suffix = arr[1].indexOf(" ") !== -1 ? arr[1].split(" ")[0] + arr[1].split(" ")[1] + arr[1].split(" ")[2] : arr[1];

            } else {
                suffix = arr[1].indexOf(" ") !== -1 ? arr[1].split(" ")[0] + arr[1].split(" ")[1] : arr[1];
            }
            pathname = prefix + "/" + suffix;

            if (pathname === CONSTANTS.PATH_SCANNER) {
                pathname = CONSTANTS.PATH_UTILITY + "/" + CONSTANTS.PATH_SCANNER
            }

            if (pathname === CONSTANTS.INITIAL_PATH_ROLES_AND_PERMISSIONS) {
                pathname = CONSTANTS.PATH_ACCOUNT_MANAGEMENT + "/" + CONSTANTS.PATH_ROLES_AND_PERMISSIONS;
            }

            if (pathname === CONSTANTS.PATH_BACKUP_AND_RESTORE) {
                pathname = CONSTANTS.PATH_UTILITY + "/" + CONSTANTS.PATH_BACKUP_AND_RESTORE;
            }


            this.setState({
                menuName: arr[0],
                subMenuName: arr[1]
            });
            if (arr[0] === CONSTANTS.MENU_MANAGE_INSTRUMENT) {
                this.setState({
                    showManageInstrument: false
                })
            }
            if (arr[0] === CONSTANTS.MENU_UTILITY) {
                this.setState({
                    showBackup: false,
                    isScannerSettingActive: false,
                    moduleName: arr[1]
                })
            }
        }
        else {
            const prefix = arr[0].indexOf(" ") !== -1 ? arr[0].split(" ")[0] + arr[0].split(" ")[1] : arr[0];
            pathname = prefix;
            this.setState({
                menuName: arr[0]
            });
        }
        this.setState({ show: false, isScannerSettingActive: false, showManageInstrument: false, showBackup: false, pathname, active, isSubMenu });
        History.push({
            pathname: `/${pathname}`
        });

    }
    private onSelectMenu = (pathname: any) => {
        this.setState({
            showConfiguration: false,
            isMeasurementDropdownShow: false,
            activeMainMenu: pathname
        });
        History.push({
            pathname: `${pathname}`
        });
    }
    private activateSubMenu = () => {
        if (this.state.menuName === CONSTANTS.MENU_MANAGE_INSTRUMENT) {
            this.setState({
                showManageInstrument: true
            });
        }
        if (this.state.menuName === CONSTANTS.MENU_UTILITY) {
            this.setState({
                showBackup: true,
                isScannerSettingActive: true
            });
        }
    }

    private handleClickOutside = () => {
        this.setState({
            show: false,
            showConfiguration: false
        });
    }

    private onCreateSample(id: string): void {
        if (id === "id") {
            History.push(CONSTANTS.SAMPLE_CREATE_URL, { formData: this.state.createData })
        } else {
            scannerActions.getById(id).then(() => {
                History.push(CONSTANTS.SAMPLE_CREATE_URL, { formData: this.state.createData, scannerData: this.state.activeItem });
            });
        }

    }

    private toggleConfiguration(toggleState: any) {
        this.setState({
            showConfiguration: !toggleState
        });
    }

    private toggleConfigMenu(toggleState: any) {
        this.setState({
            activeConfigMenu: toggleState
        });
    }

    public render() {
        return (
            <Translation>
                {
                    t =>
                        <React.Fragment>
                            <div className="navheader">
                                <div className="container-fluid ">
                                    <div className="row px-2 py-2">
                                        <div className="col-md-6 pr-md-0 row">
                                            <span className="ml-3">
                                                <WithTooltip >
                                                    <Icon name="abb/home"
                                                        sizeClass="medium"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={this.onHomeClick}
                                                    />
                                                    <Tooltip className="nav-tooltip">
                                                        <span>{t(CONSTANTS.BUTTON_HOME)}</span>
                                                    </Tooltip>
                                                </WithTooltip>
                                            </span>

                                            <div className="vertical-line line-height ml-2 mt-1" />
                                            <AppTopNavi>
                                                <AppTopNaviItem icon="abb/home" onClick={(e: any) => this.onSelectMenu(CONSTANTS.SAMPLE_INDEXNEW_URL)} ></AppTopNaviItem>
                                                <AppTopNaviItem text={t(CONSTANTS.MENU_DASHBOARD)} active={this.state.activeMainMenu === CONSTANTS.DASHBOARD_INDEX_URL ? true : false} onClick={(e: any) => this.onSelectMenu(CONSTANTS.DASHBOARD_INDEX_URL)} ></AppTopNaviItem>


                                                <AppTopNaviItem text={t('Measurement')} hasMenu={true} active={(this.state.activeMainMenu === CONSTANTS.SAMPLE_INDEX_URL
                                                    || this.state.activeMainMenu === CONSTANTS.MEASUREMENT_INDEX_URL
                                                    || this.state.activeMainMenu === CONSTANTS.MEASUREMENT_OVERVIEW_URL
                                                    || this.state.activeMainMenu === CONSTANTS.INSTRUMENT_INDEX_URL
                                                    || this.state.activeMainMenu === CONSTANTS.ROOT_URL)
                                                    ? true : false} onClick={(e: any) => this.onMeasurementClick()}></AppTopNaviItem>

                                                {this.state.isMeasurementDropdownShow &&
                                                    <div className="menu-panel">
                                                        <div className="item" onClick={() => this.onSelectMenu(CONSTANTS.SAMPLE_INDEX_URL)}>{t(CONSTANTS.MENU_SAMPLE_MEASUREMENT)}</div>
                                                        <div className="item" onClick={() => this.onSelectMenu(CONSTANTS.INSTRUMENT_INDEX_URL)}>{t(CONSTANTS.MENU_INSTRUMENTMEASUREMENT)}</div>
                                                    </div>
                                                }

                                                <AppTopNaviItem text={t(CONSTANTS.MENU_TRENDS)} active={this.state.activeMainMenu === CONSTANTS.TRENDS_INDEX_URL ? true : false} onClick={(e: any) => this.onSelectMenu(CONSTANTS.TRENDS_INDEX_URL)} />
                                                <AppTopNaviItem text={t(CONSTANTS.MENU_CONFIG)} active={(this.state.activeMainMenu !== CONSTANTS.SAMPLE_INDEX_URL
                                                    && this.state.activeMainMenu !== CONSTANTS.MEASUREMENT_INDEX_URL
                                                    && this.state.activeMainMenu !== CONSTANTS.MEASUREMENT_OVERVIEW_URL
                                                    && this.state.activeMainMenu !== CONSTANTS.ROOT_URL
                                                    && this.state.activeMainMenu !== CONSTANTS.DASHBOARD_INDEX_URL
                                                    && this.state.activeMainMenu !== CONSTANTS.TRENDS_INDEX_URL
                                                    && this.state.activeMainMenu !== CONSTANTS.INSTRUMENT_INDEX_URL) ? true : false} hasMenu={true} onClick={() => this.toggleConfiguration(this.state.showConfiguration)} ></AppTopNaviItem>
                                                {this.state.showConfiguration ? <div className="configuration-panel" id="container">
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="col-md-4 module-bg">
                                                                <div onClick={() => this.toggleConfigMenu(ConfigMenu.Modules)} className={`item ${this.state.activeConfigMenu === ConfigMenu.Modules ? 'active' : ''}`}>{t(CONSTANTS.MENU_MODULES)}</div>
                                                                <div onClick={() => this.toggleConfigMenu(ConfigMenu.Utility)} className={`item ${this.state.activeConfigMenu === ConfigMenu.Utility ? 'active' : ''}`}>{t(CONSTANTS.MENU_UTILITY)}</div>
                                                                <div className="item">&nbsp;</div>
                                                                <div className="item">&nbsp;</div>
                                                                <div className="item">&nbsp;</div>
                                                                <div className="item">&nbsp;</div>
                                                                <div className="item">&nbsp;</div>
                                                            </div>
                                                            <div className="col-md-7">
                                                                {this.state.activeConfigMenu === ConfigMenu.Modules &&
                                                                    <div>
                                                                        <div onClick={(e: any) => this.onSelectMenu(CONSTANTS.PROPERTY_INDEX_URL)} className="item">{t(CONSTANTS.MENU_PROPERTY)}</div>
                                                                        <div onClick={(e: any) => this.onSelectMenu(CONSTANTS.INSTRUMENTTYPE_INDEX_URL)} className="item">{t(CONSTANTS.SUBMENU_INSTRUMENT_TYPE)}</div>
                                                                        <div onClick={(e: any) => this.onSelectMenu(CONSTANTS.INSTRUMENT_INDEX_URL)} className="item">{t(CONSTANTS.SUBMENU_INSTRUMENT)}</div>
                                                                        <div onClick={(e: any) => this.onSelectMenu(CONSTANTS.STATION_INDEX_URL)} className="item">{t(CONSTANTS.SUBMENU_INSTRUMENT_STATION)}</div>
                                                                        <div onClick={(e: any) => this.onSelectMenu(CONSTANTS.TESTPLAN_INDEX_URL)} className="item">{t(CONSTANTS.SUBMENU_TEST_PLAN)}</div>
                                                                        <div onClick={(e: any) => this.onSelectMenu(CONSTANTS.GRADE_INDEX_URL)} className="item">{t(CONSTANTS.MENU_GRADE)}</div>
                                                                        <div onClick={(e: any) => this.onSelectMenu(CONSTANTS.PRODUCT_INDEX_URL)} className="item">{t(CONSTANTS.MENU_PRODUCT)}</div>
                                                                        <div onClick={(e: any) => this.onSelectMenu(CONSTANTS.SOURCE_INDEX_URL)} className="item">{t(CONSTANTS.MENU_SOURCE)}</div>
                                                                        
                                                                    </div>
                                                                }
                                                                {this.state.activeConfigMenu === ConfigMenu.AccManagement &&
                                                                    <div>
                                                                        <div className="item">&nbsp;</div>
                                                                    </div>
                                                                }
                                                                {this.state.activeConfigMenu === ConfigMenu.Utility &&
                                                                    <div>
                                                                        <div onClick={(e: any) => this.onSelectMenu(CONSTANTS.UTILITY_SETTING_INDEX_URL)} className="item">{t(CONSTANTS.SUBMENU_SETTINGS)}</div>
                                                                        <div onClick={(e: any) => this.onSelectMenu(CONSTANTS.SCANNER_INDEX_URL)} className="item">{t(CONSTANTS.SUBMENU_SCANNER)}</div>
                                                                        <div onClick={(e: any) => this.onSelectMenu(CONSTANTS.UTILITY_INDEX_URL)} className="item">{t(CONSTANTS.SUBMENU_BACKUP_AND_RESTORE)} </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                            <div className="col-md-1 close-btn">
                                                                <Icon name="abb/close" sizeClass="small" style={{ cursor: "pointer" }} onClick={() => this.toggleConfiguration(this.state.showConfiguration)} ></Icon>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> : null}
                                            </AppTopNavi>
                                        </div>

                                        <div className="top-right-menu col-md-6 pr-0" onClick={this.handleClickOutside}>
                                            <div className="float-right" style={{ marginTop: -2 }}>
                                                {this.state.menuName === CONSTANTS.MODULE_INSTRUMENT_DASHBOARD ?
                                                    <div>
                                                        <WithTooltip>
                                                            <Button icon="abb/alarm-bell" sizeClass="small"
                                                                className="box-icon mr-2 icon-header"
                                                            />
                                                            <Tooltip className="nav-tooltip">
                                                                {t(CONSTANTS.LABEL_ALARM)}
                                                            </Tooltip>
                                                        </WithTooltip>

                                                        <span className="vertical-line mr-3" />
                                                        <Button icon="abb/user-in-circle" sizeClass="small" className="user-button" disabled={true} />
                                                    </div>
                                                    :
                                                    this.state.moduleName === CONSTANTS.SUBMENU_BACKUP_AND_RESTORE ||
                                                        this.state.moduleName === CONSTANTS.SUBMENU_SETTINGS
                                                        ?
                                                        <div>
                                                            <span className="vertical-line mr-3" />
                                                            <Button icon="abb/user-in-circle" sizeClass="small" className="user-button" disabled={true} />
                                                        </div>
                                                        :
                                                        <div>
                                                            <WithTooltip>
                                                                <Button icon="abb/plus" sizeClass="small"
                                                                    className="box-icon mr-2 icon-header"
                                                                    onClick={this.onCreateClick} />
                                                                <Tooltip className="nav-tooltip">
                                                                    {t(CONSTANTS.CREATE)}
                                                                </Tooltip>
                                                            </WithTooltip>

                                                            {this.state.isSampleWithScanner && <AppTopNavi className="ul-class">
                                                                <Menu onLostFocus={() => this.setState({ isSampleWithScanner: false })}>
                                                                    {/* tslint:disable-next-line: jsx-no-lambda */}
                                                                    <MenuItem text={t(CONSTANTS.CREATE) + " " + t(CONSTANTS.MODULE_SAMPLE)} onSelect={() => this.onCreateSample("id")} />
                                                                    <MenuItemDivider />
                                                                    {this.state.listData.map((d, i) => {
                                                                        return <MenuItem key={i}
                                                                            text={d.name}
                                                                            // tslint:disable-next-line: jsx-no-lambda
                                                                            onSelect={() => this.onCreateSample(d.id)} />
                                                                    })}

                                                                </Menu>
                                                            </AppTopNavi>}

                                                            <WithTooltip>
                                                                <Button icon="abb/view"
                                                                    sizeClass="small"
                                                                    className={this.state.deleteId === "" ? (this.state.isEnableViewAll ? "box-icon mr-2 icon-header" : "box-icon-without-shadow mr-2 icon-header") : "box-icon mr-2 icon-header"}
                                                                    onClick={this.onViewClick}
                                                                    disabled={this.state.deleteId === "" ? (this.state.isEnableViewAll ? false : true) : false}
                                                                />

                                                                <Tooltip className="nav-tooltip">
                                                                    <p>{t(CONSTANTS.VIEW_ALL)}</p>
                                                                </Tooltip>
                                                            </WithTooltip>

                                                            <span className="vertical-line mr-3" />
                                                            {this.state.moduleName === CONSTANTS.MODULE_SAMPLE &&
                                                                <WithTooltip>
                                                                    <Button icon="abb/export"
                                                                        sizeClass="small"
                                                                        className={this.state.exportId === "" ? "box-icon-without-shadow mr-2 icon-header" : "box-icon mr-2 icon-header"}
                                                                        onClick={this.onExportCall}
                                                                        disabled={this.state.exportId === "" ? true : false}
                                                                    />
                                                                    <Tooltip className="nav-tooltip">
                                                                        <p>{t(CONSTANTS.EXPORT)}</p>
                                                                    </Tooltip>
                                                                </WithTooltip>
                                                            }

                                                            {this.state.isExportShow && <AppTopNavi className="ul-class " style={{ marginLeft: 100 }}>
                                                                <Menu onLostFocus={this.onExportCall}>
                                                                    <MenuItem text={t(CONSTANTS.MENU_SAMPLE_MEASUREMENT)} onSelect={this.onExportDataClick} />
                                                                    <MenuItem text={t(CONSTANTS.MODULE_SAMPLE)} onSelect={this.onExportClick} />
                                                                </Menu>
                                                            </AppTopNavi>}

                                                            {/* REPORT BUTTION */}
                                                            {this.state.moduleName === CONSTANTS.MODULE_SAMPLE &&
                                                                <WithTooltip>
                                                                    <Button icon="abb/reports"
                                                                        sizeClass="small"
                                                                        className={!this.state.isEnableReport ? "box-icon-without-shadow mr-2 icon-header" : "box-icon mr-2 icon-header"}
                                                                        onClick={this.onReportClick}
                                                                        disabled={!this.state.isEnableReport}
                                                                        
                                                                    />
                                                                    <Tooltip className="nav-tooltip">
                                                                        <p>{t(CONSTANTS.REPORT)}</p>
                                                                    </Tooltip>
                                                                </WithTooltip>}

                                                            {this.state.isReportDropdownShow && <AppTopNavi id="reportcontainer" className="ul-class " style={{ marginLeft: 100 }}>
                                                                <Menu >
                                                                    <MenuItem text={t(CONSTANTS.VALUE_REPORT)} onSelect={() => this.onReportLinkClick(CONSTANTS.VALUE_REPORT)} />
                                                                    <MenuItem text={t(CONSTANTS.REEL_REPORT)} onSelect={() => this.onReportLinkClick(CONSTANTS.REEL_REPORT)} />
                                                                    <MenuItem text={t(CONSTANTS.POSITION_REPORT)} onSelect={() => this.onReportLinkClick(CONSTANTS.POSITION_REPORT)} />
                                                                    <MenuItem text={t(CONSTANTS.GRAPH_REPORT)} onSelect={() => this.onReportLinkClick(CONSTANTS.GRAPH_REPORT)} />
                                                                </Menu>
                                                            </AppTopNavi>}

                                                            <WithTooltip>
                                                                <Button icon="abb/edit"
                                                                    sizeClass="small"
                                                                    className={Object.keys(this.state.editData).length === 0 ? "box-icon-without-shadow mr-2 icon-header" : "box-icon mr-2 icon-header"}
                                                                    onClick={this.onEditClick}
                                                                    disabled={Object.keys(this.state.editData).length === 0 ? true : false}
                                                                />
                                                                <Tooltip className="nav-tooltip">
                                                                    <p>{t(CONSTANTS.EDIT)}</p>
                                                                </Tooltip>
                                                            </WithTooltip>

                                                            <WithTooltip>
                                                                <Button icon="abb/trash"
                                                                    sizeClass="small"
                                                                    className={this.state.deleteId === "" ? "box-icon-without-shadow mr-2 icon-header" : "box-icon mr-2 icon-header"}
                                                                    onClick={this.openDialog}
                                                                    disabled={this.state.deleteId === "" ? true : false}
                                                                />
                                                                <Tooltip className="nav-tooltip">
                                                                    <p>{t(CONSTANTS.DELETE)}</p>
                                                                </Tooltip>
                                                            </WithTooltip>

                                                            <span className="vertical-line mr-3" />
                                                            <Button icon="abb/user-in-circle" sizeClass="small" className="user-button" disabled={true} />
                                                        </div>
                                                }
                                            </div>
                                            <div className="clearfix" />
                                        </div>
                                    </div>
                                </div>
                                <Dialog isOpen={this.state.deleteModalVisible}
                                    // tslint:disable-next-line: jsx-no-lambda
                                    onClose={() => this.setState({ deleteModalVisible: false })}
                                    showCloseButton={true}
                                    closeOnEscape={false}
                                    closeOnLostFocus={false}
                                    dimBackground={true}
                                    title={t(CONSTANTS.DELETE_TITLE, { name: this.state.deleteTitle })}
                                    standardButtonsOnBottom={[
                                        { text: t(CONSTANTS.BUTTON_CANCEL), type: 'discreet-blue', handler: dlg => dlg.close() },
                                        { text: t(CONSTANTS.BUTTON_OK), type: 'primary-blue', handler: this.onDeleteClick }
                                    ]}
                                >
                                    <div>
                                        {t(CONSTANTS.DELETE_MESSAGE, { name: this.state.deleteMessage, module: t(this.state.moduleName) })}
                                        <br />
                                        <br />
                                        <b>{t(CONSTANTS.NOTE)}:</b> {t(CONSTANTS.DELETE_POPUP_MESSAGE)}
                                    </div>
                                </Dialog>
                            </div>
                            <div className={this.state.moduleName != "Settings" ? "fixed-layout": "" } />
                        </React.Fragment>
                }
            </Translation>
        );
    }

}

export default ActionHeader;